import {InputTextV2} from '@prtimes-basis/input';
import {
  FormField,
  useFormField,
} from '@/features/company-registration/steps/input-step/form-field';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';

export function Address2Field() {
  return (
    <FormField.Root name='companyInfo.address2'>
      <Body />

      <FormField.Error />
    </FormField.Root>
  );
}

function Body() {
  const {fieldProps} = useFormField();

  return (
    <>
      <label
        htmlFor={fieldProps.id}
        className={companyRegistrationPageStyles.srOnly}
      >
        本社所在地（建物名 / 階数）
      </label>

      <InputTextV2 placeholder='住所（建物名 / 階数）' {...fieldProps} />
    </>
  );
}
